// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ySa3m","header":"ReportDetails_header__1Og55","title":"ReportDetails_title__3exRU","left":"ReportDetails_left__Q4aJ1"};